import { ChangeEvent, useState } from 'react';
import { toast } from 'react-hot-toast';
import Input from '../../../../components/common/Input/Input';
import { Button } from '../../../../components/ui/Button/Button';
import S from './CreateSchemaModalStyles';
import usePostAudioSchema from '../../../../API/hooks/devices/usePostAudioSchema';
import useGetFleetId from '../../../../API/hooks/useGetFleetId';

type Props = {
  onClose: () => void;
};

function CreateSchemaModal({
  onClose,
}: Props): JSX.Element {
  const [name, setName] = useState('');
  const fleetId = useGetFleetId();
  const onSubmitSuccess = (): any => {
    toast.success('Schema was created');
    onClose();
  };
  const onSubmitFail = (errorMessage: string): any => {
    toast.error(`Schema creating failed: ${errorMessage}`);
    // onClose();
  };
  const { mutate } = usePostAudioSchema(onSubmitSuccess, onSubmitFail);

  const handleInputChange = (e: ChangeEvent<any>): void => {
    setName(e.target.value);
  };

  return (
    <S.Wrapper>
      <Input
        name="name"
        label="Schema name"
        type="text"
        placeholder="Type new schema name"
        onChange={handleInputChange}
      />
      <div className="actions">
        <Button
          className="button"
          padding="7px 40px"
          disabled={!name || name === ''}
          onClick={() => mutate({
            fleetId,
            name,
          })}
        >
          Create
        </Button>
        <Button
          className="button"
          padding="7px 40px"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </S.Wrapper>
  );
}

export default CreateSchemaModal;
